export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  EVENTS: '/events',
  FARM_SHARE: '/farmshare',
  DETAIL_EQUIPMENT: '/farmshare/:equipmentId',
  PROFILE: '/farmshare/profile',
  ACHIEVEMENTS: '/achievements',
  ABOUT_FARMOS_CP: '/about-farmOS-CP',
  ABOUT_US: '/about-us',
  CONTACT: '/contact-us',
  RCD: '/rcd',
  RESOURCES: '/resources',
  PRIVACY: '/privacy',
  USER_LIST: '/userlist',
  RESERVATION_LIST: '/reservationlist',
  EQUIPMENT_LIST: '/equipmentlist',
  EVENT_LIST: '/eventlist',
  MY_RESERVATIONS: '/myreservations',
};
